module.exports = __webpack_public_path__ + "static/media/NawazSharif_s Shariat Bill.b61a83c8.jpg";